import React, { useMemo, useState } from 'react'
import OrderlikeLayout from '../../../../../../generic/Layouts/OrderlikeLayout'
import ControlSearchPannelLayout from '../../../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import SearchInput from '../../../../../../generic/inputs/inputSearch'
import DatePickerISO from '../../../forcasts/Distribution/Components/DatePickerISO'
import useDataFetcher from '../../../knisot/hooks/useFetchData'
import { Trucks } from '../../../../../../modules/API/Distribution/trucks'
import { format } from 'date-fns'
import TitlesList from '../../../../../../generic/titlesRowItem/TitlesList'
import KavItem from './KavItem'
import BodyScrollContainer from '../../../../../../generic/Layouts/Wrappers/BodyScrollContainer'
import { useNavigate } from 'react-router-dom'
import { LINKS } from '../../../../../../Routs/config'

type Props = {
    date: Date,
    setDate: React.Dispatch<React.SetStateAction<Date>>
}

const KavSection = ({
    date, setDate,
}: Props) => {
    const [inputValue, setInputValue] = useState<string>('')
    const navigate = useNavigate()
    const handleDate = (date: Date) => {
        setDate(date)
    }

    const {
        data: kavList,
        isLoading: loadingKavList,
    } = useDataFetcher(
        Trucks.getKavTitleList, format(date, 'yyyyMMdd')
    )

    const selectKav = (id: number) => {
        navigate(LINKS.afaca.loading.palletsGeneral + `/${id}`)
    }
    const render = useMemo(() => {
        if(!kavList) return []

        return kavList.filter(item => 
            item.AreaDesc.toLowerCase().includes(inputValue.toLowerCase()) ||
            item.DriverName.toLowerCase().includes(inputValue.toLowerCase())
        )
    }, [kavList, inputValue])

    const propsData = {
        selectKav
    }
  return (
    <OrderlikeLayout
        label='העמסה'
    >
        <ControlSearchPannelLayout>
            <DatePickerISO 
                onChange={handleDate}
                selected={date}
            />
            <SearchInput 
                input={inputValue}
                setInput={setInputValue}
            />
        </ControlSearchPannelLayout>
        <BodyScrollContainer>

            <TitlesList 
                list={render}
                uniqueKey={'AreaID'}
                noPadding={false} 
                Element={KavItem}
                additionalData={propsData}
            />
        </BodyScrollContainer>
       
    </OrderlikeLayout>
  )
}

export default KavSection

